// PostHog feature flags read by the back-office and the API.
export const FEATURE_FLAG_KEYS = [
  "advance-payment-pay-modal",
  "advance-payment-request-detail-v2",
  "commercial-conditions-list-v2",
  "consultant-kpi",
  "contact-detail-v2",
  "contacts-v2",
  "credit-score-allianz",
  "demo",
  "expense-claim-pay-modal",
  "expense-claim-request-detail-v2",
  "expense-claim-request-form-ds",
  "expense-claim-request-pbac",
  "expense-claim-request-review-sheet",
  "hiring-pool-health",
  "job-matrix-classification",
  "medical-checkup-request-form-ds",
  "medical-leave-banner",
  // TODO: "menco" swaps the whole nav bar for Menco's; split it into per-area flags (e.g. enable-crm, enable-contracts)
  "menco",
  "mission-order-form",
  "organization-select",
  "paper-timesheet-ocr",
  "pay-tracking-cooptation",
  "ppe-distribution",
  "professional-card-compliance-resolution",
  // The carte BTP request details page as read-only sections
  "professional-card-request-details-v2",
  "professional-card-update-resolution",
  "qualification-training-request-details-v2",
  "recruitment-office-invoice-request-v2",
  "remove-contact-button",
  "remuneration-elements",
  // The signature engine sends commercial conditions instead of the legacy Docuseal flow
  "signature-engine",
  "third-party-notices",
  "timesheet-v2",
  "todo-list",
  "wanted-profiles",
] as const;

export type FeatureFlagKey = (typeof FEATURE_FLAG_KEYS)[number];
